import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import '../styles/ClientList.css';

interface Client {
    name: string;
    logo: string;
    website: string;
}

const clients: Client[] = [
    {
        name: 'Bousanm - Plateforme Fintech',
        logo: '/images/clients/bousanm.webp',
        website: 'https://bousanm.com'
    },
    {
        name: 'Lycée National François Cappoix de Limonade',
        logo: '/images/clients/lnfcl.webp',
        website: 'https://lnfcl.com/'
    },
    // {
    //     name: 'Smart Systems',
    //     logo: '/images/clients/client3.jpg',
    //     website: 'https://example.com/client3'
    // },
    // {
    //     name: 'Future Tech',
    //     logo: '/images/clients/client4.jpg',
    //     website: 'https://example.com/client4'
    // },
    // {
    //     name: 'Future Tech 5',
    //     logo: '/images/clients/client4.jpg',
    //     website: 'https://example.com/client4'
    // },
    // {
    //     name: 'Future Tech 6',
    //     logo: '/images/clients/client4.jpg',
    //     website: 'https://example.com/client4'
    // },
];

const ClientList = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAutoScrolling, setIsAutoScrolling] = useState(true);
    const itemsPerPage = 4;

    useEffect(() => {
        if (!isAutoScrolling) return;

        const timer = setInterval(() => {
            setCurrentIndex((prev) => {
                const nextIndex = (prev + 1) % (clients.length - itemsPerPage + 1);
                // Si on atteint la fin, revenir au début avec une transition plus longue
                if (nextIndex === 0) {
                    setTimeout(() => setCurrentIndex(0), 500);
                    return clients.length - itemsPerPage;
                }
                return nextIndex;
            });
        }, 3000);

        return () => clearInterval(timer);
    }, [isAutoScrolling]); // clients.length et itemsPerPage sont des constantes

    const nextSlide = () => {
        setIsAutoScrolling(false);
        setCurrentIndex((prev) => (prev + 1) % (clients.length - itemsPerPage + 1));
    };

    const prevSlide = () => {
        setIsAutoScrolling(false);
        setCurrentIndex((prev) => (prev - 1 + (clients.length - itemsPerPage + 1)) % (clients.length - itemsPerPage + 1));
    };

    const resumeAutoScroll = () => {
        setIsAutoScrolling(true);
    };

    return (
        <section className="py-16 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* <div className="text-center mb-12">
                    <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                        Nos Clients
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-300">
                        Ils nous font confiance pour leurs projets
                    </p>
                </div> */}

                <div className="flex justify-center">
                    <div className="client-list-container relative w-[1000px]"
                        onMouseEnter={() => setIsAutoScrolling(false)}
                        onMouseLeave={resumeAutoScroll}>
                        <div className="client-list-track flex transition-transform duration-500 ease-out"
                            style={{ transform: `translateX(-${currentIndex * 280}px)` }}>
                            {clients.map((client, index) => (
                                <motion.a
                                    key={index}
                                    href={client.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="client-logo flex-shrink-0 relative group"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                >
                                    <div className="w-48 h-48 bg-white  rounded-xl shadow-lg p-6 transition-transform duration-300 group-hover:scale-105">
                                        <img
                                            src={client.logo}
                                            alt={`${client.name} logo`}
                                            className="w-full h-full object-contain"
                                            onError={(e) => {
                                                const target = e.target as HTMLImageElement;
                                                target.src = '/images/kolabotech.webp';
                                            }}
                                        />
                                    </div>
                                    <div className="client-overlay absolute inset-0 flex items-center justify-center rounded-xl">
                                        <div className="flex items-center space-x-2 text-white text-sm font-medium">
                                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                            </svg>
                                        </div>
                                    </div>
                                </motion.a>
                            ))}
                        </div>

                        {/* Navigation buttons */}
                        <button
                            onClick={prevSlide}
                            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 dark:bg-gray-800/80 hover:bg-white dark:hover:bg-gray-800 p-3 rounded-r-xl shadow-lg transition-all duration-200 z-10"
                            style={{ transform: `translateY(-50%) ${currentIndex === 0 ? 'translateX(-100%)' : 'translateX(0)'}` }}
                        >
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                        </button>
                        <button
                            onClick={nextSlide}
                            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 dark:bg-gray-800/80 hover:bg-white dark:hover:bg-gray-800 p-3 rounded-l-xl shadow-lg transition-all duration-200 z-10"
                            style={{ transform: `translateY(-50%) ${currentIndex >= clients.length - itemsPerPage ? 'translateX(100%)' : 'translateX(0)'}` }}
                        >
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                        </button>

                        {/* Position indicators */}
                        <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
                            {Array.from({ length: clients.length - itemsPerPage + 1 }).map((_, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => {
                                        setIsAutoScrolling(false);
                                        setCurrentIndex(idx);
                                    }}
                                    className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-blue-600 w-4' : 'bg-gray-300 dark:bg-gray-600'}`}
                                    aria-label={`Go to slide ${idx + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ClientList;